import * as React from 'react'
import { SVGProps } from 'react'
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    strokeWidth={10}
    stroke="transparent"
    height={510}
    viewBox="0 0 510 510"
    width={510}
    {...props}
  >
    <path d="m255 402.212 157.59 95.038-41.693-179.239L510 197.472l-183.37-15.734L255 12.75l-71.629 168.988L0 197.472l139.103 120.539L97.41 497.25z" />
  </svg>
)
export default SvgStar
